import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  ADBS_ROTATE_WALLET_POLL_DELAY,
  ADBS_ROTATE_WALLET_POLL_INTERVAL,
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface AdbsRotateWalletProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const AdbsRotateWallet = (
  { location, databaseId, onExecute }: AdbsRotateWalletProps,
): JSX.Element => {
  const { invokeCall: invokeRotateWallet } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).adbsDatabaseApi.updateAdbsDatabaseWallet },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(databaseId);
    const resGroup = decodeURIComponent(resourceGroup || "");
    const resName = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.rotateWallet(),
          message: Messages.notifications.inProgress.messages.rotateWallet(resName),
        },
        success: {
          title: Messages.notifications.success.titles.rotateWallet(),
          message: Messages.notifications.success.messages.rotateWallet(resName),
        },
        failure: {
          title: Messages.notifications.failure.titles.rotate(),
          message: Messages.notifications.failure.messages.rotateWallet(resName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.ADBSWALLET_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName: resGroup,
            databaseName: resName,
          },
          location,
          responseMethodKey: AsyncNotificationPolledResponseKey.ADBS_ROTATE_WALLET_CHECK,
          delay: ADBS_ROTATE_WALLET_POLL_DELAY,
          interval: ADBS_ROTATE_WALLET_POLL_INTERVAL,
        },
      },
    };

    invokeRotateWallet({
      subscriptionId,
      resourceGroupName: resGroup,
      databaseName: resName,
      updateAdbsDatabaseWalletDetails: { isRotate: true },
    }, invokeOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newAdbsRotateWallet = (
  props: AdbsRotateWalletProps,
): JSX.Element => (<AdbsRotateWallet {...props} />);
